export default {
  workstation: {
    tabs: {
      workstation: "Estação de trabalho",
      trend: "Tendência",
    },
    filters: {
      with: "Com",
      without: "Sem",
      splits: "Divisões",
      none: "Nenhuma",
    },
    sections: {
      gamelog: "Histórico de jogos",
    },
    headers: {
      line: "Linha",
      opponent: "Adversário",
    },
    labels: {
      averagePerGame: "Média por jogo",
      cover: "Cobrir",
    },
  },
};
